export const DATA_TABLE_COOKIE = Object.freeze({
  MSP_INCIDENTS_LIST: "msp-incidents-list",
  CUSTOMER_INCIDENTS_LIST: "customer-incidents-list",
  MSP_INCIDENTS_AFFECTED_USERS: "msp-incidents-affected-users",
  CUSTOMER_INCIDENTS_AFFECTED_USERS: "customer-incidents-affected-users",
  MSP_ADMINISTRATORS_LIST: "msp-administrators-list",
  CUSTOMER_ADMINISTRATORS_LIST: "customer-administrators-list",
  MSP_CUSTOMERS_LIST: "msp-customers-list",
  MSP_USAGE_CUSTOMERS_LIST: "msp-usage-customers-list",
  CUSTOMER_USAGE_CUSTOMERS_LIST: "customer-usage-customers-list",
  CUSTOMER_USAGE_PROTECTED_MAILBOXES_LIST:
    "customer-usage-protected-mailboxes-list",
  SYSTEM_MSPS_LIST: "system-msps-list",
});

export default {};
